<template>
  <div
    v-if="
      local_color_grid &&
        local_color_grid.num_rows &&
        local_color_grid.num_columns
    "
  >
    <div
      v-for="(i, row_index) in getArrayFromLength(local_color_grid.num_rows)"
      :key="`ROW${row_index}`"
      class="grid-rows"
    >
      <div
        v-for="(j, col_index) in getArrayFromLength(
          local_color_grid.num_columns
        )"
        :style="
          `background: ${setColor(row_index, col_index)};height: ${
            getBoxDimensions.height
          }px; width: ${getBoxDimensions.width}px; border: 1px solid ${
            local_color_grid.box_styles.border_color
          }`
        "
        ref="box"
        :key="`COLUMN${row_index}-${col_index}`"
        class="grid-columns"
        @mousedown.prevent="mouseDown(row_index, col_index)"
        @mouseup.prevent="mouseUp(row_index, col_index)"
        @mouseover.prevent="mouseOver(row_index, col_index)"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: "show-color-grid",
  props: {
    color_grid: {
      type: Object,
    },
  },
  data() {
    return {
      local_color_grid: this.color_grid,
      initial: null,
      final: null,
      array: [],
      drag_array: [],
      is_clicked: false,
      is_dragging: false,
    };
  },
  methods: {
    ...mapActions(['updateCurrentAnswer']),
    mouseDown(row_index, col_index) {
      this.initial = { row_index, col_index };
      this.is_clicked = true;
    },
    mouseUp(row_index, col_index) {
      this.is_clicked = false;
      this.is_dragging = false;
      this.final = { row_index, col_index };

      if (this.array && this.initial) {
        const max_row = Math.max(this.initial.row_index, this.final.row_index);
        const min_row = Math.min(this.initial.row_index, this.final.row_index);
        const max_column = Math.max(
          this.initial.col_index,
          this.final.col_index
        );
        const min_column = Math.min(
          this.initial.col_index,
          this.final.col_index
        );
        let new_array = JSON.parse(JSON.stringify(this.array));
        let is_initial_set =
          new_array[this.initial.row_index][this.initial.col_index];

        //get points between x and y
        for (let i = min_row; i <= max_row; i++) {
          for (let j = min_column; j <= max_column; j++) {
            if (is_initial_set) {
              new_array[i][j] = false;
            } else {
              new_array[i][j] = true;
            }
          }
        }
        this.array = JSON.parse(JSON.stringify(new_array))
        this.checkAnswer()
      }
    },
    mouseOver(row_index, col_index) {
      if (this.is_clicked) {
        this.is_dragging = true;

        let final = { row_index, col_index };
        const max_row = Math.max(this.initial.row_index, final.row_index);
        const min_row = Math.min(this.initial.row_index, final.row_index);
        const max_column = Math.max(this.initial.col_index, final.col_index);
        const min_column = Math.min(this.initial.col_index, final.col_index);

        if (
          this.local_color_grid.num_rows &&
          this.local_color_grid.num_columns
        ) {
          let new_array = this.ArrayOFArray();

          //get points between x and y

          for (let i = min_row; i <= max_row; i++) {
            for (let j = min_column; j <= max_column; j++) {
              new_array[i][j] = true;
            }
          }
          this.drag_array = JSON.parse(JSON.stringify(new_array));
        }
      }
    },
    getArrayFromLength(num) {
      let arr = [];
      for (let i = 0; i < num; i++) {
        arr.push(i);
      }
      return arr;
    },
    ArrayOFArray() {
      let num_rows = this.local_color_grid.num_rows;
      let num_columns = this.local_color_grid.num_columns;
      let arr = Array.from(Array(num_rows), () => new Array(num_columns));

      for (let i = 0; i < num_rows; i++) {
        for (let j = 0; j < num_columns; j++) {
          arr[i][j] = false;
        }
      }
      return arr;
    },
    isColored(row, column) {
      if (this.array && this.array[row]) {
        return this.array[row][column];
      }
    },
    isDragColored(row, column) {
      if (this.drag_array && this.drag_array[row]) {
        return this.drag_array[row][column];
      }
    },
    isShape() {
      let min_coordinate = { x: 1000000, y: 1000000 };
      let max_coordinate = { x: 0, y: 0 };
      for (let i = 0; i < this.local_color_grid.num_rows; i++) {
        for (let j = 0; j < this.local_color_grid.num_columns; j++) {
          if (this.array[i][j]) {
            if (j < min_coordinate.x) {
              min_coordinate.x = j;
            }
            if (i < min_coordinate.y) {
              min_coordinate.y = i;
            }
            if (j > max_coordinate.x) {
              max_coordinate.x = j;
            }
            if (i > max_coordinate.y) {
              max_coordinate.y = i;
            }
          }
        }
      }
      let total_boxes_inside = 0;
      let total_boxes = 0;
      for (let i = min_coordinate.y; i <= max_coordinate.y; i++) {
        for (let j = min_coordinate.x; j <= max_coordinate.x; j++) {
          if (this.array[i][j]) {
            total_boxes_inside = total_boxes_inside + 1;
          }
          total_boxes = total_boxes + 1;
        }
      }

      if (total_boxes_inside == total_boxes) {
        return true;
      } else {
        return false;
      }
    },
    setColor(row_index, col_index) {
      let bg_color = this.color_grid.box_styles.bg_color;
      if (this.is_dragging && this.isDragColored(row_index, col_index)) {
        let lightColor = this.shadeColor(bg_color, 30);
        return lightColor;
      } else if (this.is_dragging && this.isColored(row_index, col_index)) {
        return bg_color;
      } else if (!this.is_dragging && this.isColored(row_index, col_index)) {
        return bg_color;
      } else {
        return "";
      }
    },
    shadeColor(color, percent) {
      var R = parseInt(color.substring(1, 3), 16);
      var G = parseInt(color.substring(3, 5), 16);
      var B = parseInt(color.substring(5, 7), 16);

      R = parseInt((R * (100 + percent)) / 100);
      G = parseInt((G * (100 + percent)) / 100);
      B = parseInt((B * (100 + percent)) / 100);

      R = R < 255 ? R : 255;
      G = G < 255 ? G : 255;
      B = B < 255 ? B : 255;

      var RR =
        R.toString(16).length == 1 ? "0" + R.toString(16) : R.toString(16);
      var GG =
        G.toString(16).length == 1 ? "0" + G.toString(16) : G.toString(16);
      var BB =
        B.toString(16).length == 1 ? "0" + B.toString(16) : B.toString(16);

      return "#" + RR + GG + BB;
    },
    checkAnswer() {
      let is_correct = false;
      let correct_answer = this.local_color_grid.answer;
      let user_answer = 0;
      for (let i = 0; i < this.local_color_grid.num_rows; i++) {
        for (let j = 0; j < this.local_color_grid.num_columns; j++) {
          if (this.array[i][j]) {
            user_answer = user_answer + 1;
          }
        }
      }
      if (user_answer == correct_answer) {
        is_correct = true;
      }
      if (this.local_color_grid.is_answer_rectangle && !this.isShape()) {
        is_correct = false;
      }

      this.updateCurrentAnswer({key : "color_grid", value : is_correct})
    },
  },
  computed: {
    getBoxDimensions() {
      let height =
        this.local_color_grid.styles.height / this.local_color_grid.num_rows;
      let width =
        this.local_color_grid.styles.width / this.local_color_grid.num_columns;
      return { height: height, width: width };
    },
  },
  created() {
    this.array = this.ArrayOFArray();
    this.drag_array = this.ArrayOFArray();
  },
  watch: {
    color_grid: {
      handler: function(new_val) {
        this.local_color_grid = new_val;
      },
      deep: true,
    },
    local_color_grid: {
      handler: function() {
        this.array = this.ArrayOFArray();
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.grid-rows {
  display: flex;
}
.grid-columns {
  border: 1px solid black;
}
</style>
